/**
 * Add the feature names you want to fetch from the backend here
 */
export enum FeatureConfigurationFeatureName {
  UserAttendance = 'UserAttendance',
  BulkLeadActivityCreate = 'Bulk Lead Activity Create',
  LeadActivityImport = 'Lead Activity Import',
  LeadImport = 'Lead Import',
  UserImport = 'User Import',
}

export enum FeatureConfigurationDataType {
  Number = 'number',
  Integer = 'integer',
  String = 'string',
  Boolean = 'boolean',
  Json = 'json',
  Yaml = 'yaml',
}

export interface FeatureConfigurationType {
  id: string;
  featureName: FeatureConfigurationFeatureName;
  configKey: string;
  configValue: number | string | boolean | Record<string, unknown>;
  dataType: FeatureConfigurationDataType;
  createdAt: string;
  updatedAt: string;
}
